// Empty lines on all levels in <Table> ... </Table> render console-warnings
// "Whitespace text nodes cannot appear as a child ... Make sure you don't have any extra whitespace ..."
// These nodes are strings, don't render!

const renderChildNode = child => (typeof child === 'string' ? null : child);

export const renderTableChildNodes = children => {
    return Array.isArray(children) ? children.map(child => renderChildNode(child)) : renderChildNode(children);
};
